import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { debounceTime, filter, map, tap } from 'rxjs/operators';

import { StatsUpdateLogActions } from './stats-update-log.actions';
import { StatsUpdateLogQueryI } from 'src/app/api/stats-update-log/stats-update-log.query.int';

type StepLogI = {
    details: string;
    error: string;
    eventAt: string;
    updateCheckType: string;
    status: string;
    step: string;
};

@Injectable()
export class StatsUpdateLogBufferEffects {
    private readonly actions$ = inject(Actions);
    private queue: StatsUpdateLogQueryI[] = [];

    onQueue$ = createEffect(() => this.actions$.pipe(
        ofType(StatsUpdateLogActions.queue),
        tap(action => {
            this.queue.push(action.query);
        }),
    ), { dispatch: false });

    onQueueDebouncedFlush$ = createEffect(() => this.actions$.pipe(
        ofType(StatsUpdateLogActions.queue),
        debounceTime(3000),
        map(() => StatsUpdateLogActions.flush()),
    ));

    onQueueFailureFlush$ = createEffect(() => this.actions$.pipe(
        ofType(StatsUpdateLogActions.queue),
        filter(action => action.query.status === 'FAILED'),
        map(() => StatsUpdateLogActions.flush()),
    ));

    onFlush$ = createEffect(() => this.actions$.pipe(
        ofType(StatsUpdateLogActions.flush),
        filter(() => this.queue.length > 0),
        map(() => {
            const batch = this.queue.splice(0);
            const latest = batch[batch.length - 1];
            const steps: StepLogI[] = batch.map(item => ({
                details: item.details,
                error: item.error,
                eventAt: item.eventAt,
                updateCheckType: item.updateCheckType,
                status: item.status,
                step: item.step,
            }));

            return StatsUpdateLogActions.load({
                query: {
                    ...latest,
                    details: '',
                    error: '',
                    steps: JSON.stringify(steps),
                },
            });
        }),
    ));
}
